// src/hooks/useStockFetcher.tsx
/* Hook encargado de hacer la consulta a la base y 
traer Stock

Autor: Myrta Ravanal
Fecha: 2024-12-16
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Stock from '../interfaces/Stock.ts'

import { useAuth } from './useAuth.tsx'
import { makeUrlStocks } from './connectionData.tsx'

const useStockFetcher = () => {
  const [errorStock, setErrorStock] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const fetchStocks = async () => {
    setLoading(true)

    const organizationId = userData?.organization?._id ?? ''

    try {
      const apiUrl = makeUrlStocks(organizationId)
      const data = await customFetch<Stock[]>(apiUrl)
      setErrorStock(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      const myError = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorStock(myError)

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorStock, loading, fetchStocks }
}

export default useStockFetcher
